import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import TextArea from "../../components/forms-fields/TextArea";
import Input from "../../components/forms-fields/Input";
import { addHealthIssue } from "../../schemas";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { POST_HEALTH_ISSUES_URL } from "../../env";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../helper/helper";
import HealthCategories from "./HealthCategories";

function OnClickAddHealthIssue({ handleShowHide, userDataId, enumOnClickPart, handleSuccessSubmission, resolvedHealthIssue }) {
  const [userId, setUserId] = useState(userDataId);
  const [enumBodyPart, setEnumBodyPart] = useState(enumOnClickPart);
  // console.log("🚀 ~ OnClickAddHealthIssue ~ enumBodyPart:", enumBodyPart)
  const handleShowHideModal = () => {
    handleShowHide((prevShow) => !prevShow);
  };
  const [isStaffId, setIsStaffId] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [isSuFormData, setIsSuFormData] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddHealthIssue, setIsToastAddHealthIssue] = useState(false);
  const [parentSubCatValidationStatus, setParentSubCatValidationStatus] = useState(false);
  const [suFormData, setSuFormData] = useState({
    userId: userId,
    category: enumBodyPart,
    subcategory: enumBodyPart,
    healthNote: "",
    complaint: "",
    status: resolvedHealthIssue,
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldTouched,
    setFieldValue,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addHealthIssue,
    onSubmit: async (values) => {
      try {

        
        setIsSuFormData(false);
        setIsSubmitButtonClicked(true);
        await postHealthIssueFormData(values);
        handleSuccessSubmission()
      } catch (error) {
        
      }
    },
  });

  const processFetchRecords = (method, data) => {
    
    if (data?.status !== isSuccess) {
      setIsToastAddHealthIssue(true);
      toastErrorMessages(toast.error, data?.message, "", 1000, 1000);
      setIsSubmitButtonClicked(false);
      handleShowHideModal();
    } else if (
      method === "postHealthIssueFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddHealthIssue(true);
      toastSuccessMessages(toast.success, data?.message, "", 1000, 1000);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handleShowHideModal();
      }, 2000);
    }
  };

  const postHealthIssueFormData = catchAsync(async (req, res) => {
    // console.log({ req });
    const response = await postRecords(POST_HEALTH_ISSUES_URL, req);
    processFetchRecords("postHealthIssueFormData", response);
  });


  const handleInputChangePrevFields = (e) => {
    const { name, value } = e.target;
    setSuFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    handleChange(e);
    handleBlur(e);
  };






  return (
    <>
      <div className="incidents consentCapacityAddNew">
        <form onSubmit={handleSubmit}>
          <div className="formBlockContent">
            <div className="row">
              <div className="col-md-12">
                <Input
                  type="text"
                  id=""
                  name="healthNote"
                  value={values?.healthNote}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Health Note"
                  customError={touched?.healthNote && errors?.healthNote}
                  errorMessage={errors?.healthNote}
                  erroClass={
                    touched?.healthNote && errors?.healthNote
                      ? "validationError"
                      : ""
                  }
                  requiredStar={true}
                />
              </div>

              <div className="col-md-12">
                <TextArea
                  id="complaint"
                  name="complaint"
                  value={values?.complaint}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Complaint"
                  rows="3"
                  className="mb-3"
                  customError={errors.complaint && touched.complaint}
                  errorMessage={errors.complaint}
                  erroClass={errors.complaint && touched.complaint}
                  requiredStar={true}
                />
              </div>
            </div>
          </div>

          <div className="formActionButtons">
            <span
              onClick={handleShowHideModal}
              className="btn btn-sm btn-outline-primary"
            >
              Close
            </span>
            {isSubmitButtonClicked ? (
              <Button
                onClick={handleShowHideModal}
                className="btn-sm"
                variant="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Save
              </Button>
            )}
          </div>
        </form>
      </div>
      {isToastAddHealthIssue && <ToastContainer />}
    </>
  );
}

export default OnClickAddHealthIssue;
